<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
			<!--table head-->
			<v-divider color="black" />
			<v-row class="subtitle-2" no-gutters>
				<v-col class="text-left" cols="2">{{'Products' | localize}} / {{'Channels' | localize}}</v-col>
				<v-divider vertical color="black" />
				<v-col v-for="channel in channels" :key="channel.id" 
					class="text-right pr-1">
					{{ channel.name }}
				</v-col>
				<v-divider vertical color="black" />
				<v-col class="text-right text-pre-wrap pr-1 font-weight-bold">
					{{'Total sales' | localize}}, {{`\n`}} {{'units' | localize}}
				</v-col>
			</v-row>
			<v-divider color="black" />
			
			<div v-if="sales?.length > 0">

				<div v-for="item in sales" :key="item.id">
					<v-row class="body-2 my-1" no-gutters>
						<v-col class="text-left" cols="2">{{ item.trademark.name }} - {{ item.model}}</v-col>
						<v-divider vertical />
						<v-col v-for="channel in channels" :key="channel.id" 
							class="text-right pr-1">
							{{ formatNumber(salesByChannel(item, channel)) }}
						</v-col>
						<v-divider vertical />
						<v-col class="text-right pr-1 font-weight-bold">{{ formatNumber(item.sales_units)}}</v-col>
					</v-row>
					<v-divider />
				</div>
			</div>
			
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
	</v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue'
import { localeNumber } from '../../../functions/common'
import Information from '../../../layouts/Information.vue';
	export default {
		data () {
			return {
				isLoaded: false,
				text: {
					en: 'The company’s product sales are segmented by sales channel to assess the relative importance of each channel to the overall business performance.',
					ro: 'Vânzările de produse ale companiei sunt clasificate pe canale de distribuție pentru a evalua importanța relativă a fiecărui canal în ceea ce privește performanța generală a afacerii.',
					ru: 'Продажи продукции компании разбиты по каналам сбыта с целью оценки относительной важности каждого канала для общей эффективности бизнеса.'
				}
			}
		},
		computed: {
			locale() {
				return this.$store.getters.locale;
			},
			team() {
				return this.$store.getters.team;
			},
			game() {
				return this.$store.getters.game;
			},
			channels() {
				return this.$store.getters.channels;
			},
			sales() {
				return this.$store.getters.sales_team;
			}
		},
		methods: {
			formatNumber(num) {
				let res = 0
				if (num) {
					res = localeNumber(num, this.locale);
				}
				return res;
			},
			salesByChannel(sales, channel) {
				const index = sales.channels.indexOf(channel.name);
				let res = index > -1 ? sales.channels_sales[index] : 0 ;
				return res;
			},
		},
		components: {Loader, Information},
		async mounted() {
			if (this.game && this.team) {
				
				const params = {
					gameId: this.game.id,
					round: this.game.round > 0 ? this.game.round - 1 : 0,
					teamId: this.team.id,
				}

				/* get last round team sales */
				if (this.sales == null) {
				
					try {
						await this.$store.dispatch('fetchTeamSales', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}

				/*  force loading last round team channels  */	
				try {	
					await this.$store.dispatch('fetchTeamChannels', params);
				} catch (error) {
					await this.$store.dispatch('setError', error.message);
				}
			}

			this.isLoaded = true;
		}
	}
</script>